import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  DID,
  GALLONS_LIMIT,
  getFuelcardUsaaFlag,
  SAVE_UPTO,
  TOTAL_LOCATION,
  USAGE_COUNT
} from "../../../v1/constants/fuelcardRequest"
import FuelYourSavings from "./FuelYourSavings"
import CaradviseFuelCard from "../../../images/LP-Hero.png"
import CaUsaaPerks from "../../../images/usaa-perks.png"
import { formatText } from "../../../v1/helpers/stringHelpers"
import { Button, Image } from "semantic-ui-react"
import FuelFeatures from "./FuelFeatures"
import FuelcardFAQ from "./FuelcardFAQ"
import ReactSVG from "react-svg"
import CrossLogo from "../../../images/rewards/cross.svg"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { closeFuelcardMarketingModal } from "../../../v1/actions/fuelcard"
import { routerPaths } from "../../../v1/constants/paths"

const FuelcardIndex = ({
  handleDrawer,
  closeFuelcardMarketingModal,
  history,
  handleRequestCardModal
}) => {
  const { t } = useTranslation("fuelcardRequest")

  const FUELCARD_FOOTER = [
    t("footerline2"),
    t("footerline3"),
    t("footerline4"),
    t("footerline5"),
    t("footerline6", { DID: DID })
  ]

  const handleFuelCardFlag = async (requestModalFlag = false) => {
    try {
      if (requestModalFlag) {
        handleRequestCardModal()
      }
      handleDrawer()
      await closeFuelcardMarketingModal()
    } catch (error) {
      console.log("Error in handleFuelCardFlag", error)
    }
  }

  const handleFuelCardSplitFlag = async () => {
    try {
      const flag = await getFuelcardUsaaFlag()
      if (!flag) {
        history.push({
          pathname: routerPaths.dashboard
        })
      }
    } catch (error) {
      console.log("Error in handleFuelCardFlag", error)
    }
  }

  useEffect(() => {
    handleFuelCardSplitFlag()
  }, [])

  return (
    <div className="fuelcard-index">
      {!window.location.href.includes(routerPaths.fuelcard) && (
        <div className="cross-logo-box">
          <ReactSVG src={CrossLogo} onClick={() => handleFuelCardFlag()} className="cross-logo" />
        </div>
      )}
      <div className="usaa-perks-logo">
        <Image src={CaUsaaPerks} />
      </div>
      <div className="caradvise-fuelcard">
        <div className="fuel-card-info">
          <p className="headerline1">{t("getTheFreeCarAdvise")}</p>
          <p className="headerline2">
            {formatText(
              t("savePerGallon", {
                GALLON: SAVE_UPTO
              }),
              "headerline2-orange"
            )}
          </p>
          <p className="headerline3">
            {t("locationCount", {
              COUNT: TOTAL_LOCATION
            })}
          </p>
          <div className="fuel-card-button-mobile">
            <Button
              onClick={() => {
                handleFuelCardFlag(true)
              }}
              className="get-my-fuel-card order-2"
            >
              {t("getMyFuelCard")}
            </Button>
          </div>
        </div>
        <Image className="fuel-card-logo" src={CaradviseFuelCard} />
      </div>
      <FuelYourSavings />
      <FuelFeatures handleFuelCardFlag={handleFuelCardFlag} />
      <div className="fuelcard-faq-container">
        <FuelcardFAQ />
      </div>
      <div className="fuelcard-footer">
        <p>
          {t("footerline1", { GALLONS_LIMIT: GALLONS_LIMIT, USAGE_COUNT: USAGE_COUNT })}
          <a
            className="underline"
            href="http://caradvise.com/usaa/"
            rel="noopener noreferrer"
            target="_blank"
          >
            caradvise.com/usaa
          </a>{" "}
          {t("footerline1_1")}
        </p>
        {FUELCARD_FOOTER.map((footer, index) => (
          <p key={index}>{footer}</p>
        ))}
      </div>
    </div>
  )
}

export default withRouter(connect(null, { closeFuelcardMarketingModal })(FuelcardIndex))
